import React from 'react'
import Paper from '@mui/material/Paper'
import AddIcon from '@mui/icons-material/AddCircleOutline'
import { Divider, styled } from '@mui/material'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'

import SearchField from './SearchField'

const AddBoxStyled = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  zIndex: 1000
}))

function SearchCreateField ({ addText, onAddClick, ...props }) {
  return (
    <SearchField
      PaperComponent={({ children, ...rest }) => (
        <Paper {...rest}>
          <AddBoxStyled onMouseDown={onAddClick}>
            <AddIcon />&nbsp;{addText}
          </AddBoxStyled>
          <Divider />
          {children}
        </Paper>
      )}
      {...props}
    />
  )
}

SearchCreateField.propTypes = {
  addText: PropTypes.string.isRequired,
  onAddClick: PropTypes.func.isRequired
}

export default SearchCreateField
